export const validateEmail = (mail = '') => {
  // eslint-disable-next-line no-useless-escape
  const emailFormat = new RegExp('^([^.@]+)(.[^.@]+)*@([^.@]+.)+([^.@]+)$');

  return emailFormat.test(mail);
};

export const validatePhone = (number = '') => {
  // eslint-disable-next-line no-useless-escape
  const numberFormat = new RegExp('^([+]?[s0-9]+)?(d{3}|[(]?[0-9]+[)])?([-]?[s]?[0-9])+$');

  return numberFormat.test(number);
};
